export default "__VITE_ASSET__CwTAEM9p__"